import { DecisionMakerIcon } from '@change/ds-icons';

import { Button, Modal, ModalBody, ModalHeader, Text } from '@change/ds-core-ui/next';

export const ViewAll: React.FC = () => {
	return (
		<Modal
			trigger={
				<div className="w-full text-center">
					<Button data-qa="legislative-bodies-show-all" className="w-full">
						View all decision maker info
					</Button>
				</div>
			}
		>
			<div key="legislative-bodies-modal">
				<ModalHeader
					leadingSlot={
						<div className="bg-fill-accent-primary-weaker text-typography-strong flex h-20 w-20 items-center justify-center rounded-full">
							<DecisionMakerIcon />
						</div>
					}
					title="All Decision Makers on this petition"
					subtitle=""
				/>
				<ModalBody>
					<div className="flex flex-col gap-4">
						<Text variant="body">Show list of all DMs here</Text>
					</div>
				</ModalBody>
			</div>
		</Modal>
	);
};
